export enum ReportType {
  PANEL = 'PANEL',
  /** Internal: maps to PANEL_V2 on the backend. Do not expose in UI routes. */
  PANEL_V2 = 'PANEL_V2',
  CLIENTS = 'CLIENTS',
  CAMPAIGNS = 'CAMPAIGNS',
  COLLECTION = 'COLLECTION',
  COLLECTORS = 'COLLECTORS',
  COLLECTION_BY_PERIOD = 'COLLECTION_BY_PERIOD',
  CAMPAIGNS_BY_MONTH = 'CAMPAIGNS_BY_MONTH',
  PORTFOLIOS = 'PORTFOLIOS',
  NOTIFICATIONS = 'NOTIFICATIONS',
  OUTBOUND_CALLS = 'OUTBOUND_CALLS',
  DUE_DATE_PERIOD = 'DUE_DATE_PERIOD',
}

//Could improve this, fine for now
export interface ReportCriteria {
  [key: string]: any;
}

export interface Report<T extends ReportCriteria = ReportCriteria> {
  type: ReportType;
  title: string;
  criteria: T;
  description?: string;
}

export type FieldType = 'text' | 'dropdown' | 'date' | 'dateRange';

export interface ReportField {
  name: string;
  type: FieldType;
  label?: string;
  options?: any[];
  required?: boolean;
  tooltip?: string;
  dateView?: 'date' | 'month';
  isMonthRange?: boolean;
  isMonthPeriod?: boolean;
}
